import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap-v5'
import {KTSVG} from '../../../_metronic/helpers'
import { OverlayTriggerType } from 'react-bootstrap-v5/lib/esm/OverlayTrigger'

interface IconTooltipProps {
  // Content to display in tooltip (required)
  content: React.ReactNode | (() => React.ReactNode)

  // Icon path (optional, defaults to info icon)
  iconPath?: string

  // Icon className (optional, defaults to 'svg-icon-3')
  iconClassName?: string

  // Tooltip placement (optional, defaults to 'right')
  placement?: 'top' | 'bottom' | 'left' | 'right'

  // Trigger type (optional, defaults to 'hover')
  trigger?: 'hover' | 'click' | 'focus' | Array<string>

  // Tooltip ID for accessibility (required)
  id: string

  // Enable rootClose for click triggers (optional, defaults to false)
  rootClose?: boolean

  // Container span styles (optional)
  containerStyle?: React.CSSProperties

  // Container span className (optional)
  containerClassName?: string
}

const IconTooltip: React.FC<IconTooltipProps> = ({
  content,
  iconPath = '/media/icons/duotune/general/gen045.svg',
  iconClassName = 'svg-icon-3',
  placement = 'right',
  trigger = 'hover',
  id,
  rootClose = false,
  containerStyle = {paddingLeft: '5px'},
  containerClassName = 'd-inline-block ',
}) => {
  // Render content as function or ReactNode
  const tooltipContent = typeof content === 'function' ? content() : content

  return (
    <OverlayTrigger
      overlay={<Tooltip id={id}>{tooltipContent}</Tooltip>}
      placement={placement}
      trigger={trigger as OverlayTriggerType | OverlayTriggerType[]}
      rootClose={rootClose}
    >
      <span className={containerClassName} style={containerStyle}>
        <KTSVG path={iconPath} className={iconClassName} />
      </span>
    </OverlayTrigger>
  )
}

export {IconTooltip}
